<template>
    <div class="chat container">
        <h2 class="teal-text center-align">Meow Chat</h2>
        <div class="card">
            <div class="card-content">
                <ul class="messages" v-chat-scroll>
                    <li v-for="message in messages" :key="message.id">
                        <span class="teal-text">{{ message.name }}</span>
                        <span class="grey-text text-darken-3">{{ message.content }}</span>
                        <span class="time grey-text">{{ message.timestamp }}</span>
                    </li>
                </ul>
            </div>
            <div class="card-action">
                <NewMessage :name="name" />
            </div>
        </div>
    </div>
</template>

<script>
import NewMessage from '@/components/NewMessage'
import db from '@/firebase/init'
import moment from 'moment'
export default {
    name: 'Chat',
    props: ['name'],
    components: {
        NewMessage
    },
    data() {
        return {
            messages: []
        }
    },
    created() {
        let ref = db.collection('messages').orderBy('timestamp')
        ref.onSnapshot(snapshot => {
            snapshot.docChanges().forEach(change => {
                if(change.type == 'added') {
                    let doc = change.doc
                    this.messages.push({
                        id: doc.id,
                        content: doc.data().content,
                        timestamp: moment(doc.data().timestamp).format('lll'),
                        name: doc.data().name
                    })
                }
            })
        })

    }
}
</script>

<style>
    .chat h2 {
        font-size: 2.6em;
        margin-bottom: 2%;
    }

    .chat span {
        font-size: 1.4em;
    }

    .chat .card-content .time {
        display: block;
        font-size: 0.8em;
    }

    .chat .messages {
        max-height: 50vh;
        overflow: auto;

    }

    .messages::-webkit-scrollbar {
        width: 5px;
        height: 8px;
        background-color: #aaa; /* or add it to the track */
    }

    /* Add a thumb */
    .messages::-webkit-scrollbar-thumb {
        background: teal; 
    }

    @media screen and (max-width: 768px) {
        .chat .card {
            box-shadow: none;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Chat.vue